<app-tabs [tabs]="tabs" [activeTab]="activeTab" [tabIdPrefix]="'message_center'"
  [containerClass]="'message-center-container'" (tabSelected)="onTabSelected($event)">

    <div class="tab-content border rounded message-center-container" id="message_center_div_tabcontent"
    *ngIf="activeTab !== 'message'">

    <div class="header-row p-2 d-flex align-items-center justify-content-end mb-0" id="message_center_div_headeractions">
      <div class="actions">
        <div class="action-button-wrapper">
          <button mat-icon-button class="icon-btn" id="message_center_button_export" matTooltip="Export" matTooltipPosition="above" (click)="downloadExcel()">
            <img src="assets/images/neveda-images/download.svg" alt="Export" aria-hidden="true" />
          </button>
        </div>

        <div class="action-button-wrapper">
          <button mat-icon-button class="icon-btn" id="message_center_button_columnchooser_btn" matTooltip="Column Chooser" matTooltipPosition="above"
            (click)="showColumnChooser = !showColumnChooser">
            <img src="assets/images/neveda-images/column-chooser.svg" alt="Column Chooser" aria-hidden="true" />
          </button>

          <div *ngIf="showColumnChooser" class="column-chooser-dialog" id="message_center_div_columnchooser">
            <div class="column-chooser-header" id="message_center_div_columnheader">
              Column Chooser
              <button class="column-chooser-close" id="message_center_button_close"
                (click)="closeColumnChooser()">&times;</button>
            </div>
            <mat-selection-list #titles class="blue-checkboxes" id="message_center_list_columns">
              <mat-list-option *ngFor="let col of allColumns" togglePosition="before"
                [selected]="visibleColumns[col.key]" [value]="col.key" [id]="'message_center_option_' + col.key"
                (click)="onColumnClick(col)"
                (keypress.enter)="onColumnKey($event, col)"
                (keypress)="onColumnKey($event, col)" [disabled]="col.disabled">
                {{ col.label }}
              </mat-list-option>
            </mat-selection-list>
          </div>
        </div>
      </div>
    </div>

    <ng-container [ngSwitch]="activeTab">
      <app-data-grid [config]="dataGridConfig"  [statusDataField]="'status'"
        [submittedStatusValues]="['Delivered']" [actionsTemplateRef]="actionsTemplate" id="message_center_grid_datagrid">
      </app-data-grid>
    </ng-container>

    <ng-template #actionsTemplate let-data>
      <div class="action-buttons-container">
        <span class="action-span-wrapper view-wrapper"
          (mouseenter)="hoverTooltipId = data.id + '-view'"
          (mouseleave)="hoverTooltipId = null" (click)="hoverTooltipId = null">
          <button type="button" class="action-icon-button"
            [id]="'message_center_button_view_' + data.id" 
            matTooltip="View"
            matTooltipPosition="above"
            (click)="viewMessage(data); $event.stopPropagation()">
            <img src="assets/images/neveda-images/eye.svg" alt="View" width="20" height="20" />
          </button>
          <span *ngIf="hoverTooltipId === (data.id + '-view')"
            class="material-symbols-outlined inverted-arrow tooltip-arrow">arrow_drop_down</span>
        </span>
      </div>
    </ng-template>

  </div>

  <div class="tab-content border rounded message-center-container"
    id="message_center_div_secure_messaging" *ngIf="activeTab === 'message'">
    <!-- Global inbox: all of the user's messages across every application (read-only).
         No entityId is sent; userId is resolved from the logged-in user's session. -->
    <in-app-message [allMessages]="true"></in-app-message>
  </div>
</app-tabs>
